"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _styles = require("@material-ui/styles");
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    fieldset: {
      margin: 0,
      padding: 0,
      border: 0,
      minWidth: 0
    },
    title: {
      width: '100%',
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.NEUTRAL600,
      borderBottom: "1px solid ".concat(theme.palette.NEUTRAL040),
      paddingBottom: theme.spacing(1)
    }
  };
});
var _default = useStyles;
exports.default = _default;